/* eslint-disable no-nested-ternary */

import { useCncFlyInState } from '../../../common/hooks/useCncFlyInState';
import { useAppSelector } from '../../../common/hooks/useThunkDispatch';
import { cartSelectors } from '../../../common/selectors/cartSelectors';
import { currentPageSelectors } from '../../../common/selectors/currentPageSelectors';
import { storeSelectors } from '../../../common/selectors/storeSelectors';
import { CncStep } from '../../../common/store/structureDefinitions/uiState';
import { ga4NavigationTracking } from '../../../common/tracking/ga4/navigation';
import tracking from '../../../common/tracking/tracking';
import { useTimeslotCncStepCloseTracking } from '../../hooks/useTimeslotCncStepCloseTracking';
import TimeslotPreview, { NoStoreSelected } from './TimeslotPreview';

const InPageContentTimeslotPreview = () => {
    const isEditOrderMode = useAppSelector(cartSelectors.isInEditOrder);
    const hasActiveStoreSelection = useAppSelector(storeSelectors.hasActiveStoreSelection);
    const gaPageTypeName = useAppSelector(currentPageSelectors.selectGaPageTypeName);

    const { setTo, initCnc } = useCncFlyInState();
    const { startTimeslotCloseTrackingContext } = useTimeslotCncStepCloseTracking();

    const goToTimeslotsSelection = () => {
        startTimeslotCloseTrackingContext();
        setTo({
            step: CncStep.TimeSlots,
            param: { timeslotSource: gaPageTypeName ?? 'unknown' },
        });
    };

    const openCnc = () => {
        tracking.cnc.openFrom.noticeRibbonDefaultStore(false);
        initCnc();
    };

    const handleClick = () => {
        ga4NavigationTracking.deliveryTime.open();
        goToTimeslotsSelection();
    };

    if (!hasActiveStoreSelection) {
        return <NoStoreSelected onClick={openCnc} />;
    }

    return <TimeslotPreview onClick={handleClick} announceTimeslotExpiration={!isEditOrderMode} />;
};

export default InPageContentTimeslotPreview;
